<div class="calendar">
  <!-- Static left descriptive column (unchanged styling) -->
  <div class="left-part">
    <div class="left-top">
      <div class="top-left-items">
        <!-- Los valores están ocultos, pero si se borran, se desconfigura el diseño -->
        <div class="week">.</div>
        <div class="dates">.</div>
        <div class="buttons">.</div>
      </div>
    </div>
    <div class="left-bottom">
      <div class="vertical-items">
        <!-- <------CAMIONES------>

        <div class="item">
          <!-- Asignados -->
          CAMIONES TOTAL
          <!-- <mat-icon>arrow_drop_down</mat-icon> -->
        </div>
        <div class="item">
          <!-- TODO: El campo ya no es editable -->
          <!-- COMODIN -->
          CAMIONES PLAZA
          <!-- <mat-icon>arrow_drop_down</mat-icon> -->
        </div>
        <div class="item">
          <!-- Indisponibles -->
          CAMIONES AVERIADOS
          <!-- <mat-icon>arrow_drop_down</mat-icon> -->
        </div>
        <div class="item">
          <!-- TODO: Campo editable -->
          OBJETIVO CAMIONES PARADOS
          <!-- <mat-icon>arrow_drop_down</mat-icon> -->
        </div>
        <div class="item">
          <!-- TODO: Campo editable -->
          CAMIONES A FUTURO
          <!-- <mat-icon>arrow_drop_down</mat-icon> -->
        </div>
        <div class="item">
          CAMIONES DISPONIBLES
          <!-- <mat-icon>arrow_drop_down</mat-icon> -->
        </div>
        <div class="item">
          CAMIONES DESEADOS CIRCULACIÓN
          <!-- <mat-icon>arrow_drop_down</mat-icon> -->
        </div>
        <div class="item">
          <!-- parats real -->
          CAMIONES PARADOS
          <!-- <mat-icon>arrow_drop_down</mat-icon> -->
        </div>

        <!-- <------CONDUCTORES------>

        <div class="item">
          CONDUCTORES TOTAL
          <!-- <mat-icon>arrow_drop_down</mat-icon> -->
        </div>
        <div class="item">
          CONDUCT. VACACIONES
          <!-- <mat-icon>arrow_drop_down</mat-icon> -->
        </div>
        <div class="item">
          CONDUCT. INDISPONIBLES
          <!-- <mat-icon>arrow_drop_down</mat-icon> -->
        </div>
        <div class="item">
          <!-- TODO: Campo editable -->
          CONDUCT. INCORPORAR
          <!-- <mat-icon>arrow_drop_down</mat-icon> -->
        </div>
        <div class="item">
          <!-- TODO: Campo editable -->
          CONDUCT. PREVISIÓN
          <!-- <mat-icon>arrow_drop_down</mat-icon> -->
        </div>
        <div class="item">
          CONDUCT. DISPONIBLES
          <!-- <mat-icon>arrow_drop_down</mat-icon> -->
        </div>

        <!-- <------SLOTS------>

        <div class="item">
          <!-- TODO: Campo editable -->
          SLOTS
          <!-- <mat-icon>arrow_drop_down</mat-icon> -->
        </div>
        <div class="item">
          SLOTS ACEPTADOS
          <!-- <mat-icon>arrow_drop_down</mat-icon> -->
        </div>
        <div class="item">
          SLOTS PENDIENTES
          <!-- <mat-icon>arrow_drop_down</mat-icon> -->
        </div>
      </div>
    </div>
  </div>

  <div class="right-columns-scroll">
    @if (isLoading) {
    <!-- Skeleton loader -->
    @for (skeletonCol of [1, 2, 3]; track $index) {
    <div class="right-column skeleton">
      <div class="top-part">
        <div class="top-right-items">
          <div class="skeleton-line week-skeleton"></div>
          <div class="skeleton-line dates-skeleton"></div>
          <div class="buttons">
            <div class="skeleton-circle"></div>
            <div class="skeleton-circle"></div>
          </div>
        </div>
      </div>
      <div class="bottom-part">
        <div class="vertical-items">
          @for (row of [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 16, 17]; track $index) {
          <div class="item">
            <div class="skeleton-line metric-skeleton"></div>
          </div>
          }
        </div>
      </div>
    </div>
    } } @else if (rightColumns.length > 0) { @for (col of rightColumns; track
    $index) {
    <div class="right-column" [class.danger]="col.danger" [class.skeleton]="isRefreshingWeek(col.weekNumber)">
      @if (isRefreshingWeek(col.weekNumber)) {
      <!-- Skeleton loader for refreshing column -->
      <div class="top-part">
        <div class="top-right-items">
          <div class="skeleton-line week-skeleton"></div>
          <div class="skeleton-line dates-skeleton"></div>
          <div class="buttons">
            <div class="skeleton-circle"></div>
            <!-- <div class="skeleton-circle"></div> -->
            <div class="skeleton-circle"></div>
          </div>
        </div>
      </div>
      <div class="bottom-part">
        <div class="vertical-items">
          @for (row of [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 16, 17]; track $index) {
          <div class="item">
            <div class="skeleton-line metric-skeleton"></div>
          </div>
          }
        </div>
      </div>
      } @else {
      <!-- Normal column content -->
      <div class="top-part">
        <div class="top-right-items">
          <div class="week">
            @if(col.danger) {
            <mat-icon>error</mat-icon>
            }
            {{ col.week }}
          </div>
          <div class="dates">{{ col.dates }}</div>
          <div class="buttons">
            @if (!isEditingWeek(col.weekNumber)) {
            <button mat-icon-button (click)="editFields(col.weekNumber)">
              <mat-icon svgIcon="edit"></mat-icon>
            </button>
            } @else {
            <button mat-icon-button (click)="editFields(col.weekNumber)">
              <mat-icon>save_alt</mat-icon>
            </button>
            <button mat-icon-button (click)="cancelFieldsEdit()">
              <mat-icon>cancel</mat-icon>
            </button>
            }
            <button mat-icon-button (click)="onRefreshClick(col.weekNumber)">
              <mat-icon>refresh</mat-icon>
            </button>
            <!-- Exportar la semana seleccionada a excel -->
            <button mat-icon-button matTooltip="Exportar semana a Excel" matTooltipShowDelay="500" (click)="exportWeekToExcel(col.weekNumber)">
              <mat-icon>file_download</mat-icon>
            </button>
          </div>
        </div>
      </div>
      <div class="bottom-part">
        <div class="vertical-items">
          @for (value of col.metrics; track $index) {
          @if (isEditingWeek(col.weekNumber) && ($index === 1 || $index === 3 || $index === 4 || $index === 12 || $index
          === 14)) {
          <!-- Editable fields: CAMIONES PLAZA (1), OBJETIVO CAMIONES PARADOS (3), CAMIONES A FUTURO (4), CONDUCT. PREVISIÓN (12), SLOTS (14) -->
          <div class="item highlighted">
            <input type="number" [(ngModel)]="col.metrics[$index]" class="metric-input" />
          </div>
          } @else if (col.danger && $index === 5) {
          <!-- CAMIONES DISPONIBLES with danger -->
          <div class="item highlighted danger">
            {{ value }}
            <mat-icon>error</mat-icon>
          </div>
          } @else if (col.danger && $index === 13) {
          <!-- CONDUCT. DISPONIBLES with danger -->
          <div class="item highlighted danger">
            {{ value }}
            <mat-icon>error</mat-icon>
          </div>
          } @else if ($index === 5 || $index === 7 || $index === 13) {
          <!-- Highlighted but not editable: CAMIONES DISPONIBLES (5), CAMIONES PARADOS (7), CONDUCT. DISPONIBLES (13) -->
          <div class="item highlighted">{{ value }}</div>
          } @else if ($index === 9) {
          <!-- CONDUCT. VACACIONES -->
          <div class="item">{{ value }}
            <button mat-icon-button matTooltip="Mostrar conductores de vacaciones" matTooltipShowDelay="1000"
              (click)="onInfoClick(col.weekNumber, 'vacation')">
              <mat-icon style="color: #2D3872">info_outline</mat-icon>
            </button>
          </div>
          } @else if ($index === 10) {
          <!-- CONDUCT. INDISPONIBLES -->
          <div class="item">{{ value }}
            <button mat-icon-button matTooltip="Mostrar conductores indisponibles" matTooltipShowDelay="1000"
              (click)="onInfoClick(col.weekNumber, 'unavailable')">
              <mat-icon style="color: #2D3872">info_outline</mat-icon>
            </button>
          </div>
          } @else {
          <div class="item">{{ value }}</div>

          } }
        </div>
      </div>
      }
    </div>
    } }
  </div>
</div>